import AppBar from "@mui/material/AppBar";
import IconButton from "@mui/material/IconButton";
import Typography from "@mui/material/Typography";
import MenuIcon from '@mui/icons-material/Menu';
import Toolbar from "@mui/material/Toolbar";
import { Bar } from "./Bar";
import { Menu } from "../menu/Menu";
import { MutableState } from "../_/utils/MutableState";
import { useContext, useState } from "react";
import { LinkType, LocationContext } from "../_/contexts/LinkContext";


export const Header = () => {
    const openMenu = MutableState.wrap(useState(false))
    const {link, setLink} = useContext(LocationContext) as LinkType
    return (
        <>
            <Bar link={link} openMenu={openMenu}/>
            <Menu openMenu={openMenu}/>
        </>
    )
};
